module.exports = __webpack_public_path__ + "static/media/mover.a93e3c68.png";